<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Добавить новую организацию
        </div>
        <OrganizationDataEntryFields @apply="apply" :buttonName="'Добавить'"/>
    </div>
</template>

<script>
import OrganizationDataEntryFields from "./OrganizationDataEntryFields";
import SVGModalClose from "../../../SVG/SVGModalClose";

export default {
name: "AddOrganization",
    components: {
        OrganizationDataEntryFields,
        SVGModalClose
    },
    methods: {
        apply(newData) {
            this.$store.dispatch('adminPanel/organizations/SAVE_ORGANIZATION', newData);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>